import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ba54f2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "usercenter-order-confirm-order" }
const _hoisted_2 = { class: "confirm-order-title" }
const _hoisted_3 = { class: "confirm-order-table" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]

import { ref, computed, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import STable from '@/components/Table/index.vue'
import FigurePay from '@/views/shopcart/components/FigurePay.vue'
import { confirmOrderDetailApi, batchPayOrderApi, editOrderGoodsAdditionApi } from '@/apis/order'
import { columns, childColumns } from './data'
import { useRoute, useRouter } from 'vue-router'
import { ElMessageBox, ElMessage } from 'element-plus'
import { useRtfix, usePlat, isD2C } from '@/store'
import NoStockModal from '@/views/shopcart/components/NoStockModal.vue'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { montageAddition } from '@/util/calcAdt'
import { showCurrentUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'
import { showModal } from '.'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const table = ref()
const tableData: any = ref([])
const pdtFee = ref(0)
const adtFee = ref(0)
const figurePayRef = ref()
const visible = ref(false)
const goods: any = ref([])
const blackGoods: any = ref([])
const tableConfig = {
  // showSelection: true,
  // showHandler: true,
  showExpand: true,
  canRowClick: true,
  rowKey: 'platformOrderId',
  setHeight: true
}
const submit = () => {
  const noAdtItem = tableData.value.filter(v => v.orderSource === 10 && v.platformOrderItems.find(k => k.noAdditionalFlag !== 1 && !k.platformOrderItemAdditionList))
  if (noAdtItem.length > 0) {
    ElMessage.warning(t('附加项验证'))
    if (!table.value?.isFilp(noAdtItem[0])) {
      table.value.expandRowChange(noAdtItem[0])
    }
    return
  }
  batchPayOrderApi({
    platformOrderIds: route.query.id?.toString().split(',') || []
  }).then((res: any) => {
    if (res.success) {
      const { stockSkus, downSkus, validSkus, blackSkuList } = res.data
      if (stockSkus?.length > 0 || blackSkuList?.length > 0) {
        const list: any = []
        const blackList: any = []
        tableData.value.forEach((item: any) => {
          item.platformOrderItems.forEach((temp: any) => {
            if (stockSkus?.includes(temp.productSku) && temp.channel === 5) {
              list.push({
                ...temp,
                price: temp.actualPrice
              })
            }
            if (blackSkuList?.includes(temp.productSku)) {
              blackList.push({
                ...temp,
                price: temp.actualPrice
              })
            }
          })
        })
        if (list.length > 0 || blackList.length > 0) {
          goods.value = list
          blackGoods.value = blackList
          visible.value = true
        } else {
          ElMessage.warning(t('支付失败'))
        }
        return
      } else if (downSkus?.length || validSkus?.length) {
        ElMessage.warning(t('支付失败'))
        return
      }
      ElMessageBox.confirm(
        t('支付成功'),
        t('提示'),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: t('确定'),
          distinguishCancelAndClose: true,
          customClass: 'stupid-el',
          type: 'success',
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false
        }
      ).then(() => {
        router.push(useRtfix('OrderList'))
      })
    } else {
      if (res.code === '22010002') {
        showModal(router)
      }
      if (res.code === '22010091') {
        ElMessage.warning(t('待支付的订单才能重新支付，请确认后重新选择'))
      }
    }
  })
}
const getDetail = () => {
  confirmOrderDetailApi({
    platformOrderIds: route.query.id?.toString().split(',') || []
  }).then((res: any) => {
    if (res.success) {
      pdtFee.value = 0
      adtFee.value = 0
      tableData.value = res.data.platformOrders
      tableData.value.forEach((item: any) => {
        pdtFee.value += item.productPaymentFreezeAmount
        adtFee.value += item.productAdditionFreezeAmount
      })
      setTimeout(() => {
        table.value.expandAllChange()
      }, 100)
    }
  })
}
getDetail()
const unit = computed(() => {
  if (tableData.value.length === 0) return ''
  return showCurrentUnit(tableData.value[0]?.goodsCountry === COUNTRY.KR)
})
const orderItem: any = ref({})
const goodsRowItem: any = ref({})
const goodsAdditionList: any = ref(null)
const additionCountryCode: any = ref({})
const additionVisible: any = ref(false)
const openAddition = (row: any, order: any) => {
  goodsRowItem.value = {
    ...row,
    platformOrderItemAdditionDTOList: (row.platformOrderItemAdditionList === '-' ? [] : row.platformOrderItemAdditionList ?? [])?.map((item: any) => {
      return {
        ...item,
        washedlabelSpecification:
          item.washedlabelSpecification === '-'
            ? ''
            : item.washedlabelSpecification,
        spotCheckRatio: item.spotCheckRatio && item.spotCheckRatio !== '-' ? item.spotCheckRatio : ''
      }
    })
  }
  orderItem.value = order
  goodsAdditionList.value = row.platformOrderItemAdditionList?.map((item: any) => {
    return {
      ...item,
      washedlabelSpecification: item.washedlabelSpecification === '-' ? '' : item.washedlabelSpecification
    }
  }) ?? []
  additionCountryCode.value = order.goodsCountry
  additionVisible.value = true
}
const handleAdt = (adt: any) => {
  editOrderGoodsAdditionApi({
    platformOrderId: orderItem.value?.platformOrderId,
    platformOrderItemIdList: [goodsRowItem.value.platformOrderItemId],
    cartAdditionList:
    adt === 1
      ? []
      : adt.map((i: any) => {
        return {
          shopProductSku: goodsRowItem.value.shopProductSku,
          additionConfigId: i.additionConfigId,
          additionId: i.additionId,
          ingredientsSku: i.ingredientsSku === '-' ? '' : i.ingredientsSku,
          additionExtraName: i.additionExtraName,
          washedlabelAdditionId:
            i.washedlabelAdditionId === '-' ? '' : i.washedlabelAdditionId,
          washedlabelSpecification:
            i.washedlabelSpecification === '-'
              ? ''
              : i.washedlabelSpecification,
          spotCheckRatio: i.spotCheckRatio && i.spotCheckRatio !== '-' ? i.spotCheckRatio : '',
          spotCheckFlag: i.spotCheckFlag
        }
      }),
    noAdditionalFlag: adt === 1 ? 1 : 0
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('修改成功'))
      // getDetail()
      confirmOrderDetailApi({
        platformOrderIds: route.query.id?.toString().split(',') || []
      }).then((res: any) => {
        if (res.success) {
          const data = res.data.platformOrders
          const resultOrderIndex = data.findIndex(v => v.platformOrderNo === orderItem.value.platformOrderNo)
          const tableOrderIndex = tableData.value.findIndex(v => v.platformOrderNo === orderItem.value.platformOrderNo)
          tableData.value[tableOrderIndex] = data[resultOrderIndex]
          pdtFee.value = 0
          adtFee.value = 0
          tableData.value.forEach((item: any) => {
            pdtFee.value += item.productPaymentFreezeAmount
            adtFee.value += item.productAdditionFreezeAmount
          })
        }
      })
    }
  })
}
const noAdd = (row: any, order: any) => {
  orderItem.value = order
  goodsRowItem.value = row
  handleAdt(1)
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('确认订单信息')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(STable, {
        tableData: tableData.value,
        columns: _unref(columns),
        tableConfig: tableConfig,
        showPagination: false,
        ref: (_value, _refs) => {
          _refs['table'] = _value
          table.value = _value
        }
      }, {
        expand: _withCtx(({ scope }) => [
          _createVNode(STable, {
            tableData: scope.row.platformOrderItems,
            columns: _unref(childColumns),
            showPagination: false
          }, {
            productSkuImg: _withCtx(({ row }) => [
              _createElementVNode("img", {
                src: row.productSkuImg,
                alt: "",
                style: {"width":"60px"}
              }, null, 8, _hoisted_4)
            ]),
            frezeeQuantity: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.freezeQuantity) + "/" + _toDisplayString(row.sellQuantity), 1)
            ]),
            platformOrderItemAdditionList: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionList)) + " ", 1),
              (row.productType === 1 && scope.row.orderSource === 10)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _withDirectives(_createVNode(_component_el_radio, {
                      "model-value": row.noAdditionalFlag === 1,
                      size: "small",
                      label: true,
                      style: {"margin-right":"0"},
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                      onChange: ($event: any) => (noAdd(row, scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
                      ]),
                      _: 2
                    }, 1032, ["model-value", "onChange"]), [
                      [_vShow, (!row.platformOrderItemAdditionList?.length || row.platformOrderItemAdditionList === '-')]
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        onClick: _withModifiers(($event: any) => (openAddition(row, scope.row)), ["stop"])
                      }, _toDisplayString(_unref(t)('编辑')), 9, _hoisted_6)
                    ]),
                    _withDirectives(_createElementVNode("div", { class: "add-valid-text" }, _toDisplayString(_unref(t)('附加项验证')), 513), [
                      [_vShow, (!row.platformOrderItemAdditionList && row.noAdditionalFlag !== 1)]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            actualPrice: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row.actualPrice) + " " + _toDisplayString(_unref(unit)), 1)
            ]),
            productAdditionFreezeAmount: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row.productAdditionFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
            ]),
            totalFreezeAmount: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row.totalFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
            ]),
            _: 2
          }, 1032, ["tableData", "columns"])
        ]),
        productPaymentFreezeAmount: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(row.productPaymentFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
        ]),
        productAdditionFreezeAmount: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(row.productAdditionFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
        ]),
        totalFreezeAmount: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(row.totalFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
        ]),
        _: 1
      }, 8, ["tableData", "columns"])
    ]),
    _createVNode(FigurePay, {
      hiddenGroupBtn: true,
      onSubmit: submit,
      pdtFee: pdtFee.value,
      adtFee: adtFee.value,
      ref: (_value, _refs) => {
        _refs['figurePayRef'] = _value
        figurePayRef.value = _value
      },
      emitSubmit: true
    }, null, 8, ["pdtFee", "adtFee"]),
    _createVNode(NoStockModal, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      goods: goods.value,
      blackGoods: blackGoods.value
    }, null, 8, ["visible", "goods", "blackGoods"]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (goodsAdditionList.value)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              list: goodsAdditionList.value,
              "onUpdate:list": _cache[2] || (_cache[2] = ($event: any) => ((goodsAdditionList).value = $event)),
              onCommit: handleAdt,
              type: "AdtOrder",
              proxy: goodsRowItem.value,
              countryCode: additionCountryCode.value,
              noSpot: goodsRowItem.value.orderQuantity === 1
            }, null, 8, ["list", "proxy", "countryCode", "noSpot"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }))
  ]))
}
}

})